import DateRangePicker from "components/wps/DateRangePicker";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ApiService from "utills/ApiService";
import { Select, Option, Button, Popover, PopoverHandler, PopoverContent, Typography } from "@material-tailwind/react";
import { SearchIcon } from "@heroicons/react/outline";

const FilterGroup = (props: any) => {
  const { isMobile, openSearchBox, setOpenSearchBox, translate, search, setSearch, setFilter, setApplyDate, setPage, applyDate, token } = props;

  const [roleList, setRoleList] = useState<Object[]>([]);

  const [role, setRole] = useState('');

  const status_list = [
    {
      value: '',
      label: translate('all-status')
    },
    {
      value: true,
      label: translate('active')
    },
    {
      value: false,
      label: translate('in-active')
    },
  ];

  const [status, setStatus] = useState('');
  const [fetchData, setFetchData] = useState(false);

  useEffect(() => {
    if (search.status !== '') {
      status_list.forEach((item: any) => {
        if (item.value.toString() === search.status) {
          setStatus(item.value);
        }
      });
    } else {
      setStatus('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    if (roleList?.length > 0) {
      if (search.role_id !== '') {
        roleList.forEach((item: any) => {
          if (item.value === search.role_id) {
            setRole(item.value);
          }
        });
      } else {
        setRole('');
      }
    }
  }, [search, roleList]);

  useEffect(() => {
    if (token !== '') {
      const intervalFetchData = setInterval(() => {
        setFetchData(true);
        clearInterval(intervalFetchData);
      }, 100);
    }
  }, [token]);

  useEffect(() => {
    if (fetchData) {
      fetchListRole();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData]);

  const fetchListRole = async () => {
    try {
      const result = await ApiService.get(`role/all/ids`, token);

      if (result) {
        const roles = [
          {
            value: '',
            label: translate('all-role-name')
          }
        ] as any;
        result.forEach((item: any) => {
          const obj = {
            value: item.id,
            label: item.name
          };

          roles.push(obj);
        });

        setFilter(true);
        setRoleList([...roles]);
      }
    } catch (error: any) {
      // toast.error(error.message);
    }
  }

  const handleChangeSearchValue = (value: any, type: string) => {
    const values = { ...search } as any;

    values[type] = value;

    if (type === 'status') {
      setStatus(value);
    }

    if (type === 'role_id') {
      setRole(value);
    }

    setSearch({ ...values });
  }

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      setFilter(true);
    }
  };

  if (!isMobile) {
    return (
      <div className="w-full bg-white rounded-[8px] p-[16px] grid grid-cols-5 gap-[4px] flex items-end" onKeyDown={handleKeyDown}>
        <div className="w-full">
          <div className="text-14 font-500 mb-[8px]">{translate('search')}</div>

          <input className="w-full rounded-[4px] text-12 border border-[#e5e7eb]"
            onChange={(e: any) => handleChangeSearchValue(e.target.value, 'q')}
            placeholder={translate('placeholder-search-account')}
            value={search.q} />
        </div>

        <div className="w-full">
          <div className="text-14 font-500 mb-[8px]">{translate('created-date')}</div>

          <DateRangePicker
            isMobile={isMobile}
            quickSelectDate={true}
            applyDate={applyDate}
            setApplyDate={setApplyDate}
          />
        </div>

        <div className="w-full">
          <div className="text-14 font-500 mb-[8px]">{translate('role-name')}</div>

          <div className='select-role'>
            {
              roleList.length > 0 &&
              <Select
                value={role}
                onChange={(val) => handleChangeSearchValue(val, 'role_id')}
                {...{} as any}
              >
                {
                  roleList.map((item: any, index: number) => {
                    return (
                      <Option key={`${item.value}_${index}`}
                        value={item.value}>{item.label}</Option>
                    )
                  })
                }
              </Select>
            }

          </div>

        </div>

        <div className="w-full">
          <div className="text-14 font-500 mb-[8px]">{translate('status')}</div>

          <div className='select-role'>
            <Select
              value={status}
              onChange={(val) => handleChangeSearchValue(val, 'status')}
              {...{} as any}
            >
              {
                status_list.map((item: any, index: number) => {
                  return (
                    <Option key={`${item.value}_${index}`}
                      value={item.value}>{item.label}</Option>
                  )
                })
              }
            </Select>
          </div>
        </div>

        <Button
          {...{} as any} className="px-[16px] h-[40px] flex gap-[8px] items-center justify-center bg-white rounded-[4px] border border-brand-500 text-brand-500 text-14" onClick={() => {
            setFilter(true)
            setPage(1);
          }}>
          <SearchIcon className="size-[16px] text-brand-500" />

          <span className="text-16 font-500 text-brand-500">{translate('search')}</span>
        </Button>
      </div>
    )
  } else {
    return (
      <Popover placement="bottom" open={openSearchBox} handler={setOpenSearchBox}>
        <PopoverHandler {...{} as any}>
          <div className="btn-search">
            <SearchIcon className="w-7 h-7" />
          </div>
        </PopoverHandler>
        <PopoverContent
          {...{} as any}
          className="w-96">
          <Typography
            {...{} as any}
            className="!text-14 !font-500 mb-[8px]">
            {translate('search')}
          </Typography>

          <input className="w-full rounded-[4px] mb-[16px] border border-[#C5CCD2] text-14"
            placeholder={translate("placeholder-search-account")}
            onChange={(e: any) => handleChangeSearchValue(e.target.value, 'q')}
            value={search.q} />

          <Typography
            {...{} as any}
            className="!text-14 !font-500 mb-[8px]">
            {translate('created-at')}
          </Typography>

          <div className="w-full mb-[16px]">
            <DateRangePicker
              quickSelectDate={true}
              isMobilemobile={isMobile}
              applyDate={applyDate}
              setApplyDate={setApplyDate}
            />
          </div>

          <Typography
            {...{} as any}
            className="!text-14 !font-500 mb-[8px]">
            {translate('role-name')}
          </Typography>

          <div className='w-full mb-[16px]'>
            {
              roleList.length > 0 &&
              <Select
                value={role}
                onChange={(val) => handleChangeSearchValue(val, 'role_id')}
                {...{} as any}
              >
                {
                  roleList.map((item: any, index: number) => {
                    return (
                      <Option key={`${item.value}_${index}`}
                        value={item.value}>{item.label}</Option>
                    )
                  })
                }
              </Select>
            }

          </div>

          <Typography
            {...{} as any}
            className="!text-14 !font-500 mb-[8px]">
            {translate('status')}
          </Typography>

          <div className='w-full mb-[16px]'>
            <Select
              value={status}
              onChange={(val) => handleChangeSearchValue(val, 'status')}
              {...{} as any}
            >
              {
                status_list.map((item: any, index: number) => {
                  return (
                    <Option key={`${item.value}_${index}`}
                      value={item.value}>{item.label}</Option>
                  )
                })
              }
            </Select>
          </div>

          <Button
            {...{} as any}
            className="w-full rounded-[4px] border border-brand-500 bg-white flex items-center justify-center gap-[8px]" onClick={() => {
              setOpenSearchBox(false);
              setFilter(true);
              setPage(1);
            }}>
            <SearchIcon className="size-[16px] text-brand-500" strokeWidth={3} />

            <span className="text-16 text-brand-500">{translate('search')}</span>
          </Button>
        </PopoverContent>
      </Popover>
    )
  }
}

export default FilterGroup;